import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2504c700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "table_root" }
const _hoisted_2 = { class: "head_list" }
const _hoisted_3 = { class: "table_footer_fixed" }
const _hoisted_4 = { class: "results_div" }
const _hoisted_5 = { class: "fw_700 ms-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 15 }, "15", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 30 }, "30", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 100 }, "100", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "pages_container" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {
        sortBy: _ctx.localPagedRequest.sortBy,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.pagedRequest.sortBy = $event))
      }, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "backoffice_Risultati",
            text: "Risultati",
            afterText: ":"
          }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.totalItems), 1)
        ]),
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            class: "fw_700",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localPagedRequest.paging.itemsPerPage) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePage()))
          }, _hoisted_10, 544), [
            [_vModelSelect, _ctx.localPagedRequest.paging.itemsPerPage]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
        }, " < "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: _normalizeClass({selected: _ctx.selectedPage == i}),
            onClick: ($event: any) => (_ctx.setSelectedPage(i))
          }, _toDisplayString(i), 11, _hoisted_12))
        }), 128)),
        _createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
        }, " > ")
      ])
    ])
  ]))
}